import chroma from "chroma-js";

export const generateTint = (rgbArr, lightnessPercent) => {
  let factor = lightnessPercent / 100;

  rgbArr = rgbArr.map((value) => {
    let newValue = value + (255 - value) * factor;
    return Math.round(newValue);
  });

  return rgbArr;
};

export const generateShade = (rgbArr, darknessPercent) => {
  let factor = (100 - darknessPercent) / 100;

  rgbArr = rgbArr.map((value) => {
    return Math.round(value * factor);
  });

  return rgbArr;
};

// brightness of the color
export function findLuminance(rgbArr) {
  // find linear rgb value
  let [lr, lg, lb] = rgbArr.map((value) => {
    value = value / 255;
    if (value <= 0.04045) {
      return value / 12.92;
    } else {
      return Math.pow((value + 0.055) / 1.055, 2.4);
    }
  });

  // 0 to 1 scale
  return lr * 0.2126 + lg * 0.7152 + lb * 0.0722;
}

export function isContrastColor(rgbArr) {
  let luminance = findLuminance(rgbArr);
  return luminance >= 0.5;
}

export function getRGB(hex) {
  const _chroma = chroma(hex);
  return [_chroma.rgb(), _chroma.alpha()];
}

export function rgbToHex(rgba) {
  const toHex = (value) => {
    const hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  };

  const rgbaValues = rgba.match(/\d+/g).map(Number);

  const red = toHex(rgbaValues[0]).toUpperCase();
  const green = toHex(rgbaValues[1]).toUpperCase();
  const blue = toHex(rgbaValues[2]);
  const hexValue = `#${red}${green}${blue}`.toUpperCase();

  return hexValue;
}
